import { render, staticRenderFns } from "./product-qr-code-badge.vue?vue&type=template&id=c6acbda4&"
import script from "./product-qr-code-badge.vue?vue&type=script&lang=js&"
export * from "./product-qr-code-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports